import { Modal } from "antd";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Input from "../../../components/input";
import Button from "../../../components/button";
import { Plus } from "lucide-react";
import useRequest from "../../../components/hooks/use-request";
import { showToast } from "../../../components/toast";
import { CircleLoader } from "react-spinners";
import Select from "../../../components/select";

interface UserModalProp {
  isVisible: boolean;
  onClose: () => void;
  roles: any
}

const AddUser: React.FC<UserModalProp> = ({ isVisible, onClose, roles }) => {
  const { loading, makeRequest } = useRequest("/auth/invite", "POST");
  const { handleSubmit, control, reset } = useForm();

  const handleAddUser = handleSubmit(async (formData) => {
    const inviteUser = {
      email: formData.email,
      role: formData.role,
      username: formData.username,
    };
    const [response] = await makeRequest(inviteUser);
    if (response.status) {
      showToast(response.message, true, {
        position: "top-right",
      });
      reset();
      window.location.reload()
    } else {
      showToast(response?.message, false, {
        position: "top-right",
      });
    }
  });
  return (
    <Modal visible={isVisible} onCancel={onClose}  
     width="80%"
        centered={true}
        footer={null}
        style={{
          padding: 0,
          margin: 0,
          maxWidth: "1200px",
          height: "auto",
        }}
    >
      <h2 className="text-[#272728] text-[30px] font-semibold">Add New User</h2>
      <form onSubmit={handleAddUser}>
        <div className="grid gap-4">
          <div className=" items-center gap-4">
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Enter a valid email.",
                },
              }}
              render={({ field, fieldState }) => (
                <Input
                  label="Email"
                  value={field.value}
                  placeholder="Enter Email"
                  className="w-full "
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                  autoComplete="off"
                />
              )}
            />{" "}
          </div>

          <Controller
            name="username"
            control={control}
            rules={{
              required: "Full Name is required",
            }}
            render={({ field, fieldState }) => (
              <Input
                value={field.value}
                className="w-full"
                label="Username"
                placeholder="Enter Full Name"
                error={fieldState?.error?.message}
                onChange={field.onChange}
                autoComplete="off"
              />
            )}
          />

          <div className="items-center gap-4 mt-2">
            
            <Controller
              name="role"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Select
                  name="role"
                  options={roles.map((role: any) => ({
                    value: role.name, 
                    label: role.name, 
                  }))}
                  className="w-full "
                  label="Role"
                  onChange={(selectedValue) => {
                    field.onChange(selectedValue);
                  }}
                  value={field.value}
                />
              )}
            />
          </div>

        </div>
        <div className="flex justify-end gap-3 pt-14">
          <Button
            size="lg"
            variant="primary"
            type="submit"
            className="font-normal"
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              <div className="flex gap-3">
                <Plus /> Add New User
              </div>
            )}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AddUser;
